/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import * as jose from 'jose';

// UPDATE URL WITH PROD AND QA ENV VARIABLE
const JWKS = jose.createRemoteJWKSet(
  new URL(
    `${process.env.REACT_APP_KEYCLOAK_AUTH_URL}/protocol/openid-connect/certs`,
  ),
);
export class AWSKeycloakService {
  parsedToken: any = null;
  rawToken: any = null;
  isTokenValid = async(token: string): Promise<boolean> => {
    try {
      await jose.jwtVerify(token, JWKS, {
        issuer: `${process.env.REACT_APP_KEYCLOAK_AUTH_URL}`,
        audience: 'bite_client_local',
      });
      return true;
    } catch (error) {
      console.error('Error verifying token:', error);
      return false;
    }
  };
  private decodeToken = async(tokenObject: any) => {
    try {
      const decodedToken = await jwtDecode(tokenObject.access_token);

      this.parsedToken = decodedToken;
      this.rawToken = tokenObject;
    } catch (error) {
      console.error('Error decoding:', error);
    }
  };
  refreshToken = async(token: any) => {
    const data = new URLSearchParams();
    data.append('client_id', 'bite_client_local');
    data.append('grant_type', 'refresh_token');
    data.append('refresh_token', token ? token : this.rawToken.refresh_token);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_KEYCLOAK_AUTH_URL}/protocol/openid-connect/token`,
        data,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        },
      );
      await this.decodeToken(response.data);
    } catch (error) {
      console.error('Login From AWS', error);
    }
  };

  getToken = () => this.rawToken.access_token;

  getUser = () => {
    return {
      id: this.parsedToken?.sub,
      name: this.parsedToken?.name,
      email: this.parsedToken?.email,
      resource_access: this.parsedToken?.resource_access,
      realm_roles: this.parsedToken?.roles,
    };
  };
  // could use admin client here

  getUsername = () => this.parsedToken?.preferred_username;

  // Checks if User has the Realm Role, "bite-admin" (Super Admin User for all BITE groups)
  isBiteAdmin = () =>
    this.parsedToken?.roles.includes('bite-admin');

  isServiceAccount = () =>
    this.parsedToken?.roles.includes('service-account');
  hasRealmRoles = (roles: string[]) => {
    roles.some((role) => this.parsedToken?.roles.includes(role));
  };
  // Checks if any roles in a roles array are realm roles
  doLogout = () => {
    this.parsedToken = null;
    this.rawToken = null;
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = `${process.env.ROOT_URL}`;
  };
}
export {};
